import React from 'react';
import { secondaryColor } from '../../../data-service/backend-functions/helpers.js';
import audience from '../../../images/icon/audience-def.svg';
import branded from '../../../images/icon/branded.svg';
import reports from '../../../images/icon/monthly-reports.svg';
import support from '../../../images/icon/support.svg';
import { Card } from './card.jsx';
const advantages = [
  {
    icon: audience,
    title: 'Custom audience definition',
    text: 'Filter by board certification, location, billing codes, or taxonomy',
  },
  {
    icon: branded,
    title: 'Branded outreach',
    text: 'Run display and video ads across platforms HCPs already use',
  },
  {
    icon: reports,
    title: 'Monthly engagement reports',
    text: 'Get lists of clinicians who interacted with your messaging, along with contact details and specialties',
  },
  {
    icon: support,
    title: 'Support for follow-up',
    text: 'Use these reports to equip recruiters for warm, customized outreach',
  },
];

export const Advantages = () => {
  return (
    <div className="py-[40px] lg:py-[80px] container">
      <h2 className="mb-20 text-[30px] lg:text-[50px] font-bold text-center">
        Multiply the Impact of Your <br /> Networking and Referrals
      </h2>
      <p style={{ fontSize: '18px' }} className="text-center text-lg">
        This transforms occasional in-person interactions into a longer
        engagement window by <br /> combining offline presence with strategic
        digital support. A typical campaign includes:
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'center',
          margin: '0,auto',
          gap: '30px',
          justifySelf: 'center',
        }}
        className="advantages"
      >
        {advantages.map((advantage) => (
          <Card
            icon={advantage.icon}
            title={advantage.title}
            text={advantage.text}
            minHeight="350px"
          />
        ))}
      </div>
    </div>
  );
};
